import type { ReactNode } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { isPeriodOverPeriodToggleSupported } from "./isPeriodOverPeriodToggleSupported";
import { PeriodOverPeriod } from "./PeriodOverPeriod";

const { carbon } = colorsPalettes;

const Delimiter = styled.div`
    width: 1px;
    height: 24px;
    background-color: ${carbon[100]};
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    &:hover > :first-child,
    &:hover > :first-child * {
        box-shadow: none;
    }
`;

export const PeriodOverPeriodWrapper = ({ children }: { children: ReactNode }) => {
    if (!isPeriodOverPeriodToggleSupported()) {
        return children;
    }
    return (
        <Container>
            {children}
            <Delimiter />
            <PeriodOverPeriod />
        </Container>
    );
};

PeriodOverPeriodWrapper.Delimiter = Delimiter;
PeriodOverPeriodWrapper.Container = Container;
PeriodOverPeriodWrapper.Toggle = PeriodOverPeriod;
